import React from 'react';
import PropTypes from 'prop-types';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {InstructorSearch} from './InstructorSearch';
import {NonProfileInstructorComponent} from './NonProfileInstructorComponent';

export class InstructorComponent extends React.Component {
    static get props() {
        return {
            activeCollection: PropTypes.Object.isRequired,
            contactInfo: PropTypes.Object.isRequired,
            searchInstructorInfo: PropTypes.func.isRequired,
            getInsObject: PropTypes.func.isRequired
        };
    }
    constructor(props){
        super(props);
        this.state = {
            instEmail:  this.props.contactInfo.instructor && this.props.contactInfo.instructor.email?this.props.contactInfo.instructor.email:'',
            instFirstName: this.props.contactInfo.instructor && this.props.contactInfo.instructor.firstName?this.props.contactInfo.instructor.firstName:'',
            instLastName: this.props.contactInfo.instructor && this.props.contactInfo.instructor.lastName?this.props.contactInfo.instructor.lastName:'',
            instUsername: this.props.contactInfo.instructor && this.props.contactInfo.instructor.username?this.props.contactInfo.instructor.username:'',
            activateSaveBtn:false,
            addNonProfileInstructor:false,
            saveInstructorObj: this.props.contactInfo.instructor

        };
        this.changeInstructorData = this.changeInstructorData.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.contactInfo !== nextProps.contactInfo) {
            this.setState({
                instEmail:  nextProps.contactInfo.instructor && nextProps.contactInfo.instructor.email?nextProps.contactInfo.instructor.email:'',
                instFirstName: nextProps.contactInfo.instructor && nextProps.contactInfo.instructor.firstName?nextProps.contactInfo.instructor.firstName:'',
                instLastName: nextProps.contactInfo.instructor && nextProps.contactInfo.instructor.lastName?nextProps.contactInfo.instructor.lastName:'',
                instUsername: nextProps.contactInfo.instructor && nextProps.contactInfo.instructor.username?nextProps.contactInfo.instructor.username:''
            });
        }

    }
    changeInstructorData(valueObj,dataType){
        const valueFormatted = valueObj;
        switch (dataType){
            case 'email':
                this.setState({instEmail: valueFormatted,activateSaveBtn: true});
                break;
            case 'firstName':
                this.setState({instFirstName: valueFormatted,activateSaveBtn: true});
                break;
            case 'username':
                this.setState({instUsername: valueFormatted,activateSaveBtn: true});
                break;
            case 'lastName':
                this.setState({instLastName: valueFormatted,activateSaveBtn: true});
                break;
            case 'all':
                this.setState({
                    instEmail: valueObj.email,
                    instFirstName: valueObj.firstName,
                    instLastName: valueObj.lastName,
                    instUsername: valueObj.username,
                    saveInstructorObj: valueObj.saveInstructorObj,
                    activateSaveBtn: true,
                    addNonProfileInstructor: false
                });
                break;
            case 'non-profile':
                this.setState({
                    instEmail: valueObj.email,
                    addNonProfileInstructor: true
                });
                break;
            case 'add-profile':
                this.setState({
                    activateSaveBtn: valueObj.state,
                    saveInstructorObj: valueObj.saveInstructorObj,
                });
                break;
            default:
                return false;
        }
        setTimeout(()=>{
            this.props.getInsObject(this.state.saveInstructorObj);
        },100);
    }

    render() {
        const geoId = this.props.activeCollection.geo && this.props.activeCollection.geo.id ? this.props.activeCollection.geo.id : '';
        return (
            <div className="instructor-component">
                <div className="inst-search-wrapper">
                    <InstructorSearch
                        searchInstructorInfo={this.props.searchInstructorInfo}
                        options={{geoId: geoId, unscrubbed: this.props.activeCollection.unscrubbed}}
                        changeInstructorData={this.changeInstructorData}
                    />
                </div>
                {this.state.addNonProfileInstructor && <NonProfileInstructorComponent changeInstructorData={this.changeInstructorData}></NonProfileInstructorComponent>}
                {!this.state.addNonProfileInstructor && <div className="inst-table-wrapper">
                    <div className="row">
                        <div className="col1">
                            <label className="pe-label--bold">Email</label>
                        </div>
                        <div className="col2">
                            <label className="pe-label">: {this.state.instEmail}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col1">
                            <label className="pe-label--bold">Instructor Name</label>
                        </div>
                        <div className="col2">
                            <label className="pe-label">: {this.state.instFirstName} {this.state.instLastName}</label>
                        </div>
                    </div>
                    {this.state.saveInstructorObj && this.state.saveInstructorObj.id ? this.state.instUsername ?
                        <div className="row">
                            <div className="col1">
                                <label className="pe-label--bold">Username</label>
                            </div>
                            <div className="col2">
                                <label className="pe-label"> {': ' + this.state.instUsername} </label>
                            </div>
                        </div>
                        : ''
                        : <div className="row">
                            <div className="col1">
                                <label className="pe-label--bold">Username</label>
                            </div>
                            <div className="col2">
                                <label className="pe-label"> : No Account </label>
                            </div>
                        </div>}
                </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/InstructorComponenent.js